import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '../store/store'
import AddressForm from "./AddressForm.jsx"

document.addEventListener('DOMContentLoaded', () => {
  const addressFormWrapper = document.querySelector('[data-address-form]')
  if(addressFormWrapper) {
    const addressFormRoot = createRoot(addressFormWrapper)
    addressFormRoot.render(
      <Provider store={store}>
        <AddressForm />
      </Provider>)
  }
})